export default "__VITE_ASSET__nciemkld__"